import UIButton from 'UIComponents/button/UIButton';
import { useState } from 'react';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import DisabledAlertBase from './DisabledAlertBase';
import TemplateSendModal, { TWENTY_FOUR_HR_REPLY } from './TemplateSendModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisabledAlertTemplateSelectorButton = ({
  genericChannelId,
  recipientId,
  message,
  threadId,
  messageLimitData
}) => {
  const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  const showWhatsAppModal = showModal && genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.capability-editor.disabled-editor.send-template"
      })
    }), showWhatsAppModal && /*#__PURE__*/_jsx(TemplateSendModal, {
      handleClose: handleClose,
      message: message,
      recipientId: recipientId,
      threadId: threadId
      // the only possible value right now is TWENTY_FOUR_HR_REPLY since agent
      // doesn't have the ability to send adhoc templates manually
      ,
      templateInitiationType: TWENTY_FOUR_HR_REPLY,
      messageLimitData: messageLimitData
    })]
  });
};
DisabledAlertTemplateSelectorButton.displayName = 'DisabledAlertTemplateSelectorButton';
const getAlertMessage = genericChannelId => {
  switch (genericChannelId) {
    case WHATSAPP_GENERIC_CHANNEL_ID:
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "composer-ui.capability-editor.disabled-editor.whatsapp.template_jsx",
          elements: {
            UILink
          }
        });
      }
    default:
      {
        return null;
      }
  }
};
const DisabledAlertTemplateSelector = ({
  recipientId,
  message,
  threadId,
  messageLimitData
}) => {
  const genericChannelId = getGenericChannelId(message);
  return /*#__PURE__*/_jsx(DisabledAlertBase, {
    message: getAlertMessage(genericChannelId),
    type: 'warning',
    button: /*#__PURE__*/_jsx(DisabledAlertTemplateSelectorButton, {
      genericChannelId: genericChannelId,
      recipientId: recipientId,
      message: message,
      threadId: threadId,
      messageLimitData: messageLimitData
    })
  });
};
DisabledAlertTemplateSelector.displayName = 'DisabledAlertTemplateSelector';
export default DisabledAlertTemplateSelector;